module.exports = __webpack_public_path__ + "img/white-logo-grexy.6064a38c.svg";